import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GLEnvironment } from '../../types/env';
import { StorageService } from '../storage/storage.service';

@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  static isProduction(): boolean {
    return environment.production;
  }

  static env(): GLEnvironment {
    return environment.environment;
  }

  static showStyleLibrary(): boolean {
    return (
      environment.environment !== GLEnvironment.PRODUCTION &&
      environment.environment !== GLEnvironment.STAGING
    );
  }

  static apiUrl(): string {
    return environment.apiUrl;
  }

  static clarityID(): string {
    return environment.microsoftClarityID || '';
  }

  static googleAnalyticsID(): string {
    return environment.googleAnalyticsID;
  }

  static sessionTimeoutMinutes: number = environment.sessionTimeoutMinutes;

  static unleashUrl(): string {
    return environment.unleash.url;
  }

  static unleashClientKey(): string {
    return environment.unleash.clientKey;
  }

  static getStreamApiKey(): string {
    return environment.getstream_key;
  }

  static getStreamAppId(): string {
    return environment.getstream_appid;
  }

  static pusherInfo(key: string): string {
    switch (key) {
      case 'key':
        return environment.pusher.key;
      case 'cluster':
        return environment.pusher.cluster;
      default:
        return '';
    }
  }

  static googleOAuthClientId(): string {
    return environment.googleOAuthClientId;
  }

  static cleverClientId(): string {
    return environment.cleverClientId;
  }

  static cleverRedirectURI(): string {
    return environment.cleverRedirectURI;
  }

  // CKEditor configuration helpers
  static ckEditorLicenseKey(): string {
    return environment.ckEditor.licenseKey;
  }

  static ckEditorCloudTokenUrl(): Promise<string> {
    return new Promise((resolve, reject) => {
      const bearer = StorageService.getAuthToken()?.token;
      const tokenUrl = `${this.apiUrl()}/ckeditor/token`;

      const xhr = new XMLHttpRequest();

      xhr.open('GET', tokenUrl);

      xhr.addEventListener('load', () => {
        const statusCode = xhr.status;
        const xhrResponse = xhr.response;

        if (statusCode < 200 || statusCode > 299) {
          return reject(new Error('Cannot download a new token!'));
        }

        return resolve(xhrResponse);
      });

      xhr.addEventListener('error', () => reject(new Error('Network error')));
      xhr.addEventListener('abort', () => reject(new Error('Abort')));

      xhr.setRequestHeader('Authorization', `Bearer ${bearer}`);

      xhr.send();
    });
  }

  static ckEditorWebSocketUrl(): string {
    return environment.ckEditor.cloudServices.websocketUrl;
  }

  static ckEditorBundleVersion(): string {
    return environment.ckEditor.cloudServices.bundleVersion;
  }

  static ckEditorEnvironmentId(): string {
    return environment.ckEditor.environmentId;
  }
}
